import React from "react";
import { Button } from "react-bootstrap";
import InputMask from "react-input-mask";

import "./AudioRooms.css";

import { DtoAudioRoomProps } from "../../core/dto/dashboard.dto";
import { useAppDispatch, useAppSelector } from "../../core/redux/hooks";
import { terminateVoiceCall, setInCallNotificationIdRef, terminateOutBoundVoiceCall, setVoiceCallAudioMute, setOutBoundCallPhoneNumber, setAudioCallStartTimer, setInDirectCall, playPauseRinger, setOutBoundCallFromPhoneNumber, setOutBoundCallConnection, setAgentToAgentOutBoundVoiceCallAgentDetails, disableAddParticipantButton, setEnableDisableDropDown } from "../../core/redux/notificationsSlice";
import { PhoneNumberFormatterWithCode, GetTenantId, PhoneNumberFormatter, RevertFormattedPhoneNumber, DisplayToaster, checkCallSid, loggerHelper } from "../../core/services/sharedService";
import { showToaster } from "../../core/redux/toastSlice";
import AppLoader from "../AppLoader/AppLoader";
import { PostApiMethod } from "../../core/services/apiService";
import Teams from "../Teams/Teams"
import AppModal from "../AppModal/AppModal";
import DeviceChoice from "../Settings/DeviceChoice";
import AgentStatusInfoTooltip from "./AgentStatusInfoTooltip";


const AudioRooms = ({
    TenantNotificationDetails,
    inBoundCallConnection,
    outBoundCallLocationDetails,
    inCallNotificationIdRef,
    twilioDevice,
    voiceAudioMute,
    outBoundCallPhoneNumber,
    outBoundCallFromPhoneNumber,
    audioCallTimer,
    sendOutBoundVoiceCallSocketEmit,
    notificationData,
    outBoundCallConnection,
    agentToAgentOutBoundVoiceCallAgentDetails,
    holdCallDetails,
    putCallOnHold,
    addThirdPersonToCallHandler,
    outBoundCallAddParticipant
}: DtoAudioRoomProps) => {
    const dispatch = useAppDispatch();
    let LoginUserDetails = useAppSelector((state) => state.auth.users);

    let notificationsSliceSelector = useAppSelector(
        (state: any) => state.agentNotification
    );

    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const vendorId = GetTenantId();
    const [NameDetails, setNameDetails] = React.useState<any>({});
    const [incomingAgentDetails, setIncomingAgentDetails] = React.useState<any>();
    // const [outBoundCallCountryCode] = React.useState<string>("+1");
    const [outBoundCallPhoneNumberLocal, setOutBoundCallPhoneNumberLocal] = React.useState<string>(outBoundCallPhoneNumber);
    const [incomingCallVerifiedPhNumber, setIncomingCallVerifiedPhNumber] = React.useState<string>("");
    const [addThirdUserFlag, setAddThirdUserFlag] = React.useState<boolean>(false);
    const [addThirdUserButton, setAddThirdUserButton] = React.useState<boolean>(false);
    // const [localDeviceFlag, setLocalDeviceFlag] = React.useState<boolean>(false);

    const [showKeypadInboundCall, setShowKeypadInboundCall] = React.useState<boolean>(false);
    const [ssmAPITenantData, setSsmAPITenantData] = React.useState<any>({});

    React.useEffect(() => {
        console.log(TenantNotificationDetails, 'TenantNotificationDetails ****************************');
        let finalAudioInputDevice: any = localStorage.getItem('selectedAudioInputDevice') ? localStorage.getItem('selectedAudioInputDevice') : "";
        let finalAudioOutputDevice: any = localStorage.getItem('selectedAudioOutputDevice') ? localStorage.getItem('selectedAudioOutputDevice') : "";
        if (
            TenantNotificationDetails &&
            TenantNotificationDetails.hasOwnProperty("tenant_info") &&
            TenantNotificationDetails.tenant_info &&
            TenantNotificationDetails.application_id &&
            TenantNotificationDetails.tenant_info.applicationData &&
            TenantNotificationDetails.tenant_info.applicationData[TenantNotificationDetails.application_id] &&
            TenantNotificationDetails.tenant_info.applicationData[TenantNotificationDetails.application_id][0] &&
            TenantNotificationDetails.tenant_info.applicationData[TenantNotificationDetails.application_id][0].data
        ) {
            setNameDetails(TenantNotificationDetails.tenant_info.applicationData[TenantNotificationDetails.application_id][0].data.contact);
        } else if (TenantNotificationDetails && TenantNotificationDetails.hasOwnProperty("tenant_info") && TenantNotificationDetails['tenant_info'] != null && TenantNotificationDetails['tenant_info']?.length > 0) {
            setSsmAPITenantData(TenantNotificationDetails['tenant_info']);
        } else if (TenantNotificationDetails && TenantNotificationDetails.agent_name && TenantNotificationDetails.agent_email) {
            setIncomingAgentDetails({ agentName: TenantNotificationDetails.agent_name, agentEmail: TenantNotificationDetails.agent_email });
        }
        else {
            setNameDetails({});
        }
        // stating the voice call timer
        if (inCallNotificationIdRef) {
            dispatch(setAudioCallStartTimer(true));
        }
        if (agentToAgentOutBoundVoiceCallAgentDetails && agentToAgentOutBoundVoiceCallAgentDetails._id && !inCallNotificationIdRef) {
            outBoundCallTriggerHandler(true);
            dispatch(setAudioCallStartTimer(true));
        }
        if (finalAudioInputDevice) {
            twilioDevice?.audio?.setAudioConstraints({ echoCancellation: true })
                .then(() => {
                    twilioDevice?.audio?.setInputDevice(finalAudioInputDevice);
                });
        }
        if (finalAudioOutputDevice) {
            twilioDevice?.audio?.speakerDevices?.set(finalAudioOutputDevice);
        }


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        if ((TenantNotificationDetails && !TenantNotificationDetails.third_agent && TenantNotificationDetails.addParticipant) || (outBoundCallAddParticipant)) {
            setAddThirdUserButton(true);
        } else {
            setAddThirdUserButton(false);
        }
    }, [TenantNotificationDetails, outBoundCallConnection, TenantNotificationDetails?.third_agent, TenantNotificationDetails?.addParticipant, outBoundCallAddParticipant]);

    const checkOutBoundCallLocationDetails = React.useCallback(() => {
        if (outBoundCallLocationDetails && !inBoundCallConnection && !TenantNotificationDetails) {
            if (!inCallNotificationIdRef) {
                if (outBoundCallLocationDetails.customer_contact) {
                    setIsLoading(true);
                    PostApiMethod("twilio/verify-callerid", { "phone": `+${outBoundCallLocationDetails.customer_contact}` })
                        .then((res) => {
                            setIsLoading(false);
                            if (res.data.response && res.data.response.length > 0) {
                                dispatch(setOutBoundCallFromPhoneNumber(outBoundCallLocationDetails.customer_contact!));
                            } else {
                                dispatch(setOutBoundCallFromPhoneNumber(`${outBoundCallLocationDetails.contact}`));
                            }
                        })
                        .catch((err) => {
                            setIsLoading(false);
                            dispatch(setOutBoundCallFromPhoneNumber(`${outBoundCallLocationDetails.contact}`));
                        });
                } else {
                    dispatch(setOutBoundCallFromPhoneNumber(`${outBoundCallLocationDetails.contact}`));
                }
            } else {
                setOutBoundCallPhoneNumberLocal(outBoundCallPhoneNumber);
            }
        }
    }, [TenantNotificationDetails, inBoundCallConnection, dispatch, inCallNotificationIdRef, outBoundCallLocationDetails, outBoundCallPhoneNumber])

    React.useEffect(() => {
        checkOutBoundCallLocationDetails();
    }, [outBoundCallLocationDetails]);

    const DateFormat = (data: string) => {
        try {
            const dateVal = new Date(data);
            return ("00" + (dateVal.getMonth() + 1)).slice(-2) + "-" + ("00" + dateVal.getDate()).slice(-2) + "-" + dateVal.getFullYear();
        } catch (error) {
            return "";
            console.log(error, "error in dateFormat ===========>");
        }
    }

    const muteAudioTracks = React.useCallback((status: boolean) => {
        if (inBoundCallConnection) {
            inBoundCallConnection.mute(!status);
        } else if (outBoundCallConnection) {
            outBoundCallConnection.mute(!status);
        }
    }, [inBoundCallConnection, outBoundCallConnection]);

    // Handle audio muted events
    const handleAudioMute = React.useCallback(() => {
        dispatch(setVoiceCallAudioMute(!voiceAudioMute));
        muteAudioTracks(voiceAudioMute);
    }, [dispatch, muteAudioTracks, voiceAudioMute]);

    const sendDigit = React.useCallback((digits: string, callType: string = "outgoing") => {
        if (callType === "outgoing") {
            if (inCallNotificationIdRef) {
                if (outBoundCallConnection) {
                    outBoundCallConnection.sendDigits(digits);
                }
            } else {
                setOutBoundCallPhoneNumberLocal(digits);
            }
        } else {
            if (callType === "incoming") {
                let pattern = /^[0-9#*]/;
                if (!pattern.test(digits)) {
                    DisplayToaster("bg-danger", "Please enter valid numbers and characters(*,#)");
                    return false;
                } else {
                    if (inBoundCallConnection) {
                        setIncomingCallVerifiedPhNumber((currentDigit: any) => { return currentDigit + digits });
                        inBoundCallConnection.sendDigits(digits);
                    }
                    else if (outBoundCallConnection) {
                        setIncomingCallVerifiedPhNumber((currentDigit: any) => { return currentDigit + digits });
                        outBoundCallConnection.sendDigits(digits);
                    }
                }
            }
        }
    }, [inBoundCallConnection, inCallNotificationIdRef, outBoundCallConnection]);

    // on phone number keypad backspace
    const backSpace = React.useCallback((callType: string = "outgoing") => {
        if (callType === "outgoing") {
            if (outBoundCallPhoneNumberLocal && outBoundCallPhoneNumberLocal.length > 1) {
                setOutBoundCallPhoneNumberLocal((previousState: string) => { return previousState.split("", previousState.length - 1).join("") });
            } else {
                setOutBoundCallPhoneNumberLocal("");
            }
        } else {
            if (incomingCallVerifiedPhNumber && incomingCallVerifiedPhNumber.length > 1 && callType === "incoming") {
                setIncomingCallVerifiedPhNumber((previousState: string) => { return previousState.split("", previousState.length - 1).join("") })
            } else {
                setIncomingCallVerifiedPhNumber("");
            }
        }
    }, [incomingCallVerifiedPhNumber, outBoundCallPhoneNumberLocal])

    const checkIncomingVoiceCall = React.useCallback(() => {
        if (notificationData && notificationData.length > 0) {
            if (notificationData.filter((notificationInstance: any) => notificationInstance.call_type && notificationInstance.call_type === "voice").length > 0) {
                if (notificationData.length === 1 && holdCallDetails && holdCallDetails.callSid && holdCallDetails.callSid) {
                    return false
                }
                return true;
            }
        }
        return false;
    }, [holdCallDetails, notificationData]);

    // out bound voice call handler
    const outBoundCallTriggerHandler = React.useCallback(async (call: boolean) => {

        if (call && checkIncomingVoiceCall()) {
            dispatch(showToaster(
                {
                    dialogBgColor: 'bg-danger',
                    dialogMsg: "Can’t initiate an outgoing call when you are receiving an incoming voice call notification.",
                    showDialog: true,
                    timer: '5000'
                }
            ));
            dispatch(terminateOutBoundVoiceCall());
            dispatch(setInDirectCall(false));
            dispatch(setOutBoundCallPhoneNumber(""));
            setOutBoundCallPhoneNumberLocal("");
            dispatch(setOutBoundCallConnection(undefined));
            dispatch(setAgentToAgentOutBoundVoiceCallAgentDetails(undefined));
            return false;
        }
        if (!inCallNotificationIdRef && outBoundCallLocationDetails && call) {
            if (outBoundCallPhoneNumberLocal && RevertFormattedPhoneNumber(outBoundCallPhoneNumberLocal).length >= 10) {
                // make outbound call with current number
                const outBoundCallPhoneNumberWithCountryCode = `1${RevertFormattedPhoneNumber(outBoundCallPhoneNumberLocal)}`;
                let outBoundCallParameters: { To: string, From: string, callerBound: string, locationId: string, callSid?: string, vendorId: string, agentId: string } = {
                    To: outBoundCallPhoneNumberWithCountryCode,
                    From: `+${outBoundCallFromPhoneNumber}`,
                    callerBound: "outgoing call",
                    locationId: outBoundCallLocationDetails._id,
                    vendorId: vendorId,
                    agentId: LoginUserDetails._id
                };
                dispatch(playPauseRinger(false));
                dispatch(setInDirectCall(true));
                dispatch(setAudioCallStartTimer(true));
                dispatch(setInCallNotificationIdRef((outBoundCallLocationDetails && outBoundCallLocationDetails._id) ? outBoundCallLocationDetails._id : undefined));
                dispatch(setOutBoundCallPhoneNumber(outBoundCallPhoneNumberLocal.replace(/\D/g, '')));
                loggerHelper("Before connecting the outgoing voip call", outBoundCallParameters);
                const callConnection = await twilioDevice.connect({
                    params: outBoundCallParameters,
                });
                outBoundCallParameters.To = outBoundCallPhoneNumberLocal.replace(/\D/g, '');
                outBoundCallParameters.From = outBoundCallFromPhoneNumber;
                // hang up call in progress
                callConnection.on('disconnect', function () {
                    dispatch(terminateOutBoundVoiceCall());
                    dispatch(setInDirectCall(false));
                    dispatch(setOutBoundCallPhoneNumber(""));
                    setOutBoundCallPhoneNumberLocal("");
                });
                callConnection.on("accept", () => {
                    loggerHelper("After connecting outgoing voip call", outBoundCallParameters);
                    outBoundCallParameters.callSid = callConnection.parameters.CallSid;
                    sendOutBoundVoiceCallSocketEmit(outBoundCallParameters);
                    dispatch(setOutBoundCallConnection(callConnection));
                });
                dispatch(setOutBoundCallConnection(callConnection));
            } else {
                // show error message if invalid phone number
                dispatch(showToaster(
                    {
                        dialogBgColor: 'bg-danger',
                        dialogMsg: "Enter a valid phone number",
                        showDialog: true,
                        timer: '5000'
                    }
                ));
            }
        } else if (agentToAgentOutBoundVoiceCallAgentDetails && call) {

            const vendorId = GetTenantId();
            let agentToAgentCallParameters: { From: string, To: string, agentToEmail: string, agentName: string, agentEmail: string, agentId: string, callerBound: string, vendorId: string, callSid?: string } = {
                From: LoginUserDetails.name,
                To: agentToAgentOutBoundVoiceCallAgentDetails.name,
                agentToEmail: agentToAgentOutBoundVoiceCallAgentDetails.email,
                agentName: LoginUserDetails.name,
                agentEmail: LoginUserDetails.email,
                agentId: agentToAgentOutBoundVoiceCallAgentDetails._id,
                callerBound: "agent call",
                vendorId: vendorId,
            }
            loggerHelper("Before connecting agent to agent call", agentToAgentCallParameters)
            try {
                const callConnection = await twilioDevice.connect({
                    params: agentToAgentCallParameters
                })
                dispatch(playPauseRinger(false));
                dispatch(setInDirectCall(true));
                dispatch(setAudioCallStartTimer(true));
                dispatch(setInCallNotificationIdRef(LoginUserDetails._id));

                // hang up call in progress
                callConnection?.on('disconnect', function () {
                    loggerHelper("while hang up the call");
                    dispatch(terminateOutBoundVoiceCall());
                    dispatch(setAgentToAgentOutBoundVoiceCallAgentDetails(undefined));
                    dispatch(setInDirectCall(false));
                });
                callConnection?.on("accept", () => {
                    agentToAgentCallParameters.callSid = callConnection.parameters.CallSid;
                    sendOutBoundVoiceCallSocketEmit(agentToAgentCallParameters);
                    dispatch(setOutBoundCallConnection(callConnection));
                });
                dispatch(setOutBoundCallConnection(callConnection));
            } catch (err) {
                loggerHelper("err while connecting the agent to agent call", err);
            }



        }
        else {
            if (outBoundCallConnection) {
                twilioDevice.disconnectAll()
                outBoundCallConnection.removeAllListeners();
            }
            dispatch(terminateOutBoundVoiceCall());
            dispatch(setInDirectCall(false));
            dispatch(setAgentToAgentOutBoundVoiceCallAgentDetails(undefined));
        }
    }, [checkIncomingVoiceCall, inCallNotificationIdRef, outBoundCallLocationDetails, agentToAgentOutBoundVoiceCallAgentDetails, dispatch, outBoundCallPhoneNumberLocal, outBoundCallFromPhoneNumber, vendorId, LoginUserDetails._id, LoginUserDetails.name, LoginUserDetails.email, twilioDevice, sendOutBoundVoiceCallSocketEmit, outBoundCallConnection]);

    // terminate voice call handler
    const terminateCall = React.useCallback(() => {

        if (inBoundCallConnection) {
            dispatch(terminateVoiceCall({ callerId: inBoundCallConnection['customParameters'].get('call_sid'), disconnectCall: true }));
        } else {
            outBoundCallTriggerHandler(false);
        }
    }, [inBoundCallConnection, dispatch, outBoundCallTriggerHandler]);

    const addThirdUsers = React.useCallback((agentDetails: any) => {
        dispatch(disableAddParticipantButton());
        const addThirdPersonToCallPayload = {
            agentToEmail: agentDetails.email,
            agentToName: agentDetails.name,
            agentName: LoginUserDetails.name,
            agentEmail: LoginUserDetails.email,
            agentId: agentDetails._id,
            callType: 'voice',
            callSid: (inBoundCallConnection) ? checkCallSid(inBoundCallConnection['customParameters'].get('call_sid')) : (outBoundCallConnection) ? checkCallSid(outBoundCallConnection.parameters.CallSid) : undefined
        }
        addThirdPersonToCallHandler(addThirdPersonToCallPayload);
        setAddThirdUserFlag(false);
    }, [LoginUserDetails.email, LoginUserDetails.name, addThirdPersonToCallHandler, dispatch, inBoundCallConnection, outBoundCallConnection])

    const initiateCallOnPressEnter = (e: any) => {
        if (e.keyCode === 13) {
            e.preventDefault();
            outBoundCallTriggerHandler(true);
        }
    };

    const disableBackSpace = (e: any) => {
        if (e.keyCode === 8) {
            e.preventDefault();
        }
    };

    React.useEffect(() => {
        if (notificationsSliceSelector.triggersetSinkId) {
            let finalAudioInputDevice: any = localStorage.getItem('selectedAudioInputDevice') ? localStorage.getItem('selectedAudioInputDevice') : "";
            let finalAudioOutputDevice: any = localStorage.getItem('selectedAudioOutputDevice') ? localStorage.getItem('selectedAudioOutputDevice') : "";
            if (Object.keys(notificationsSliceSelector.notificationAudioDevice)[0] === "selectedAudioInputDevice") {
                twilioDevice.audio.setInputDevice(finalAudioInputDevice).then(() => {
                    console.info('Success! *****');
                    dispatch(setEnableDisableDropDown(""));
                });
            }

            let speakerDevices = twilioDevice.audio.speakerDevices.get();

            if (Object.keys(notificationsSliceSelector.notificationAudioDevice)[0] === "selectedAudioOutputDevice") {
                twilioDevice.audio.speakerDevices.set(finalAudioOutputDevice).then(() => {
                    dispatch(setEnableDisableDropDown(""));
                });
            }
        }
    }, [notificationsSliceSelector.triggersetSinkId])

    let makeFormatting = React.useCallback((HeadrerName: string, data: any = " - ") => {
        return (
            <div className="row mb-1">
                <div className="col-4">
                    {HeadrerName}
                </div>
                <div className="col-8">
                    : {data ? data : (data === 0 ? data : " - ")}
                </div>
            </div>
        )
    }, [])

    const formatDate = React.useCallback((rawDate: string) => {
        try {
            const date = new Date(rawDate);
            const formattedDate = date.toISOString().split("T")[0];
            return formattedDate;
        } catch (error) {
            return "";
            console.log(error, 'error while formatting the date');
        }

    }, []);

    return (
        <div className="d-flex align-items-end row audio-room-container">

            <div className="card audio-details-card col-12" >
                <div className="card-body">
                    {
                        (inBoundCallConnection && TenantNotificationDetails && !outBoundCallLocationDetails && !agentToAgentOutBoundVoiceCallAgentDetails) ?
                            <>
                                {
                                    (NameDetails && !incomingAgentDetails) && ((NameDetails && Object.keys(NameDetails).length > 0)) ?
                                        (
                                            <div>
                                                <h3 className="card-title">Tenant Details - {
                                                    (NameDetails?.first) + " " + (NameDetails?.last)
                                                }
                                                </h3>
                                                <div>
                                                    {
                                                        <div className="m-2 tenantBorder">
                                                            {
                                                                makeFormatting("Phone Number", TenantNotificationDetails?.contact_from
                                                                    ? PhoneNumberFormatter(TenantNotificationDetails.contact_from.toString().slice(1), TenantNotificationDetails.contact_from.toString().slice(1).length)
                                                                    : " - Not Available ")
                                                            }

                                                            <div className="row">
                                                                <div className="col-4">
                                                                    <label>
                                                                        Full Address
                                                                    </label>
                                                                </div>
                                                                {
                                                                    NameDetails?.Addresses?.length > 0 ?
                                                                        NameDetails?.Addresses?.map((items: any, index: any) => (
                                                                            <div key={index} className="col-8">
                                                                                : {
                                                                                    (items.Address?.address + " , " + items.Address?.city + " , " + items.Address?.state + " , " + items.Address?.country)
                                                                                }
                                                                            </div>
                                                                        )) :
                                                                        <div className="col-8">: Not Available</div>

                                                                }
                                                            </div>

                                                            {
                                                                (NameDetails.hasOwnProperty('Leases') && NameDetails.Leases.length > 0) ?

                                                                    NameDetails.Leases?.slice().sort((a: any, b: any) => (new Date(b.start_date).valueOf() - new Date(a.start_date).valueOf())).map(
                                                                        (leaseData: any, i: number) => (
                                                                            <>
                                                                                <h4> Lease Details - {" "}
                                                                                    {
                                                                                        (leaseData?.Unit && 'Address' in leaseData.Unit && leaseData.Unit.Address && ('address2' in leaseData.Unit.Address || 'city' in leaseData.Unit.Address || 'state' in leaseData.Unit.Address))
                                                                                            ?
                                                                                            (leaseData.Unit.Address.address2 || ((leaseData.Unit.Address.state || " ") + (leaseData.Unit.Address.city ? (leaseData.Unit.Address?.state ? " - " : " ") + leaseData.Unit.Address.city : "")))
                                                                                            :
                                                                                            ('id' in leaseData ? leaseData.id : "")
                                                                                    }
                                                                                </h4>

                                                                                {makeFormatting("Location", leaseData?.Unit?.Address?.address)}

                                                                                {makeFormatting("Unit Number", leaseData?.Unit?.number)}

                                                                                {makeFormatting("Status of Lease", NameDetails?.status)}

                                                                                {makeFormatting("Start Date of Lease", leaseData?.start_date && DateFormat(leaseData.start_date))}

                                                                                {leaseData?.Metrics?.paid_through_date && makeFormatting("Paid Through Date", leaseData?.Metrics?.paid_through_date && DateFormat(leaseData?.Metrics?.paid_through_date))}

                                                                                {makeFormatting("Current Rent Rate", leaseData?.rent && ("$" + leaseData.rent))}

                                                                                {makeFormatting("Current Balance Due", leaseData?.balance && ("$" + leaseData.balance))}
                                                                            </>
                                                                        )
                                                                    ) : (
                                                                        <h4> Lease Details - Not Found</h4>
                                                                    )
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        )
                                        : (ssmAPITenantData && ssmAPITenantData?.length > 0) ? (
                                            <>
                                                <h3 className="card-title">Tenant Details - {ssmAPITenantData && (ssmAPITenantData[0]?.FirstName + " " + ssmAPITenantData[0]?.LastName)} </h3>
                                                <div className="m-2 tenantBorder">
                                                    {ssmAPITenantData &&
                                                        makeFormatting("Phone Number", ssmAPITenantData[0]?.Phone
                                                            ? PhoneNumberFormatter(ssmAPITenantData[0]?.Phone?.toString(), ssmAPITenantData[0]?.Phone?.toString()?.length)
                                                            : " - Not Available ")
                                                    }
                                                    <div className="row">
                                                        <div className="col-4">
                                                            Full Address
                                                        </div>
                                                        <div className="col-8">
                                                            {/* : {ssmAPITenantData && (ssmAPITenantData[1]?.Address) + " , " + (ssmAPITenantData[1]?.City) || " " + " , " + ssmAPITenantData[1]?.State ? ssmAPITenantData[1]?.State?.Name : " "} */}
                                                            : {
                                                                ssmAPITenantData && (
                                                                    ssmAPITenantData[0]?.Address
                                                                        ? `${ssmAPITenantData[0]?.Address}, ${ssmAPITenantData[0]?.City}, ${ssmAPITenantData[0]?.State?.Name || ''}`
                                                                        : ssmAPITenantData[1]?.Address
                                                                            ? `${ssmAPITenantData[1]?.Address}, ${ssmAPITenantData[1]?.City}, ${ssmAPITenantData[1]?.State?.Name || ''}`
                                                                            : ssmAPITenantData[2]?.Address
                                                                                ? `${ssmAPITenantData[2]?.Address}, ${ssmAPITenantData[2]?.City}, ${ssmAPITenantData[2]?.State?.Name || ''}`
                                                                                : " - "
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                    {/* <div>Full Address - {ssmAPITenantData[0].Address + " , " + ssmAPITenantData[0].City + " , " + ssmAPITenantData[0].State.Name}</div> */}
                                                    {
                                                        ssmAPITenantData?.map((item: any) => {
                                                            return (
                                                                <>
                                                                    {
                                                                        (item.Rentals && item.Rentals?.length > 0) &&
                                                                        item.Rentals?.slice().sort((a: any, b: any) => (new Date(b?.MoveInDate)?.setHours(0, 0, 0, 0).valueOf() - new Date(a?.MoveInDate)?.setHours(0, 0, 0, 0).valueOf()))?.map(((rentalDetails: any) => (
                                                                            <>
                                                                                <h4> Lease Details - {" " + rentalDetails.FacilityName ? rentalDetails.FacilityName : ""}</h4>
                                                                                {makeFormatting("Location", rentalDetails?.LocationAddress && rentalDetails?.LocationAddress[0]?.Address)}
                                                                                {makeFormatting("Unit Number", rentalDetails.UnitNumber)}
                                                                                {makeFormatting("status", rentalDetails.LeaseStatus)}
                                                                                {makeFormatting("Start Date", rentalDetails.MoveInDate && formatDate(rentalDetails.MoveInDate) && DateFormat(formatDate(rentalDetails.MoveInDate)))}
                                                                                {makeFormatting("paid Through Date", rentalDetails.PaidThruDate && formatDate(rentalDetails.PaidThruDate) && DateFormat(formatDate(rentalDetails.PaidThruDate)))}
                                                                                {makeFormatting("Current Rent Rate", rentalDetails.CurrentRent)}
                                                                                {makeFormatting("Balance", rentalDetails.BalanceDueAmount)}
                                                                            </>
                                                                        )))
                                                                    }
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </>
                                        ) :
                                            (incomingAgentDetails) ?
                                                (
                                                    <>
                                                        <h3 className="card-title">Agent Details</h3>

                                                        <div className="row">
                                                            <div className="col-6">
                                                                <label>
                                                                    Name
                                                                </label>
                                                            </div>
                                                            <div className="col-6">
                                                                : {(incomingAgentDetails && incomingAgentDetails.agentName)
                                                                    ? incomingAgentDetails.agentName
                                                                    : <span className="pl-3"> - </span>}
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <label>
                                                                    Email
                                                                </label>
                                                            </div>
                                                            <div className="col-6">
                                                                : {(incomingAgentDetails && incomingAgentDetails.agentEmail)
                                                                    ? incomingAgentDetails.agentEmail
                                                                    : <span className="pl-3"> - </span>}
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                                :
                                                (
                                                    <>
                                                        <h3 className="card-title">Tenant Details</h3>
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <label>
                                                                    Number
                                                                </label>
                                                            </div>
                                                            <div className="col-6">
                                                                : {(TenantNotificationDetails && TenantNotificationDetails.contact_from)
                                                                    ? (/^\d/.test(TenantNotificationDetails.contact_from) ? PhoneNumberFormatter(TenantNotificationDetails.contact_from.toString().slice(1), TenantNotificationDetails.contact_from.toString().slice(1).length) : TenantNotificationDetails.contact_from)
                                                                    : " - Not Available "}
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <label>
                                                                    Address
                                                                </label>
                                                            </div>
                                                            <div className="col-6">
                                                                : {TenantNotificationDetails && (
                                                                    [
                                                                        TenantNotificationDetails?.caller_city,
                                                                        TenantNotificationDetails?.caller_state,
                                                                        TenantNotificationDetails?.caller_Country
                                                                    ]
                                                                        .filter(Boolean)
                                                                        .join(", ")
                                                                )}
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                }
                            </>
                            :
                            (outBoundCallLocationDetails && !inBoundCallConnection && !TenantNotificationDetails && !agentToAgentOutBoundVoiceCallAgentDetails) ?
                                (isLoading) ?
                                    <AppLoader removeFixedHeight={true} />
                                    :
                                    <>
                                        <div className="out-bound-dialer">
                                            <h3 className="card-title">Location Details</h3>
                                            <div>
                                                <div key={1}>
                                                    <div className="row d-flex align-items-center">
                                                        <div className="col-6">
                                                            <label>Location</label>
                                                        </div>
                                                        <div className="col-6">
                                                            : {(outBoundCallLocationDetails && outBoundCallLocationDetails.name) ? outBoundCallLocationDetails.name : "-"}
                                                        </div>
                                                    </div>
                                                    <div className="row d-flex align-items-center">
                                                        <div className="col-6">
                                                            <label>
                                                                From
                                                            </label>
                                                        </div>
                                                        <div className="col-6">
                                                            : {(outBoundCallFromPhoneNumber) ? PhoneNumberFormatterWithCode(outBoundCallFromPhoneNumber.toString()) : "-"}
                                                        </div>
                                                    </div>

                                                    <div className="row d-flex align-items-center">
                                                        <div className="col-6">
                                                            <label>
                                                                To
                                                            </label>
                                                        </div>
                                                        <div className="col-6">
                                                            <div className="input-group">
                                                                <div className="input-group-prepend">
                                                                    <div className="input-group-text" id="btnGroupAddon"><b>+1</b></div>
                                                                </div>
                                                                <InputMask className="form-control" onKeyDown={initiateCallOnPressEnter} disabled={(inCallNotificationIdRef) ? true : false} value={outBoundCallPhoneNumberLocal} mask="(999)-999-99999" maskChar={null} onChange={(event) => { sendDigit(event?.target.value) }} />
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div className="keys">
                                                        <div className="key-row">
                                                            <button className="btn btn-circle btn-default" onKeyDown={initiateCallOnPressEnter} onClick={() => { (inCallNotificationIdRef) ? sendDigit('1') : sendDigit(outBoundCallPhoneNumberLocal + '1') }}>1</button>
                                                            <button className="btn btn-circle btn-default" onKeyDown={initiateCallOnPressEnter} onClick={() => { (inCallNotificationIdRef) ? sendDigit('2') : sendDigit(outBoundCallPhoneNumberLocal + '2') }}>2</button>
                                                            <button className="btn btn-circle btn-default" onKeyDown={initiateCallOnPressEnter} onClick={() => { (inCallNotificationIdRef) ? sendDigit('3') : sendDigit(outBoundCallPhoneNumberLocal + '3') }}>3</button>
                                                        </div>
                                                        <div className="key-row">
                                                            <button className="btn btn-circle btn-default" onKeyDown={initiateCallOnPressEnter} onClick={() => { (inCallNotificationIdRef) ? sendDigit('4') : sendDigit(outBoundCallPhoneNumberLocal + '4') }}>4</button>
                                                            <button className="btn btn-circle btn-default" onKeyDown={initiateCallOnPressEnter} onClick={() => { (inCallNotificationIdRef) ? sendDigit('5') : sendDigit(outBoundCallPhoneNumberLocal + '5') }}>5</button>
                                                            <button className="btn btn-circle btn-default" onKeyDown={initiateCallOnPressEnter} onClick={() => { (inCallNotificationIdRef) ? sendDigit('6') : sendDigit(outBoundCallPhoneNumberLocal + '6') }}>6</button>
                                                        </div>
                                                        <div className="key-row">
                                                            <button className="btn btn-circle btn-default" onKeyDown={initiateCallOnPressEnter} onClick={() => { (inCallNotificationIdRef) ? sendDigit('7') : sendDigit(outBoundCallPhoneNumberLocal + '7') }}>7</button>
                                                            <button className="btn btn-circle btn-default" onKeyDown={initiateCallOnPressEnter} onClick={() => { (inCallNotificationIdRef) ? sendDigit('8') : sendDigit(outBoundCallPhoneNumberLocal + '8') }}>8</button>
                                                            <button className="btn btn-circle btn-default" onKeyDown={initiateCallOnPressEnter} onClick={() => { (inCallNotificationIdRef) ? sendDigit('9') : sendDigit(outBoundCallPhoneNumberLocal + '9') }}>9</button>
                                                        </div>
                                                        <div className="key-row">
                                                            <button className="btn btn-circle btn-default" >--</button>
                                                            <button className="btn btn-circle btn-default" onKeyDown={initiateCallOnPressEnter} onClick={() => { (inCallNotificationIdRef) ? sendDigit('0') : sendDigit(outBoundCallPhoneNumberLocal + '0') }}>0</button>
                                                            <button className="btn btn-circle btn-default" onKeyDown={initiateCallOnPressEnter} onClick={() => { backSpace() }}><i className="bi bi-backspace-fill"></i></button>
                                                        </div>
                                                    </div>
                                                    {
                                                        (!inCallNotificationIdRef) ?
                                                            <div className="controls">
                                                                <button className={"btn btn-circle btn-success btn-success"}
                                                                    onClick={() => { outBoundCallTriggerHandler(true); }} >
                                                                    <i className={"bi bi-telephone-outbound-fill"}></i> &nbsp;CALL
                                                                </button>
                                                                <button className={"btn btn-circle btn-danger"}
                                                                    onClick={() => { outBoundCallTriggerHandler(false); }} >
                                                                    <i className="bi bi-telephone-x-fill"></i> &nbsp;CANCEL
                                                                </button>
                                                            </div>
                                                            :
                                                            <></>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                :
                                (agentToAgentOutBoundVoiceCallAgentDetails && !outBoundCallLocationDetails && !inBoundCallConnection && !TenantNotificationDetails) ?
                                    <>
                                        <div className="out-bound-dialer">
                                            <h3 className="card-title">Agent Details</h3>
                                            <div>
                                                <div key={1}>
                                                    <div className="row d-flex align-items-center">
                                                        <div className="col-6">
                                                            <label>Agent Name</label>
                                                        </div>
                                                        <div className="col-6">
                                                            : {(agentToAgentOutBoundVoiceCallAgentDetails && agentToAgentOutBoundVoiceCallAgentDetails.name) ? agentToAgentOutBoundVoiceCallAgentDetails.name : "-"}
                                                        </div>
                                                    </div>
                                                    <div className="row d-flex align-items-center">
                                                        <div className="col-6">
                                                            <label>
                                                                Email
                                                            </label>
                                                        </div>
                                                        <div className="col-6">
                                                            : {(agentToAgentOutBoundVoiceCallAgentDetails && agentToAgentOutBoundVoiceCallAgentDetails.email) ? agentToAgentOutBoundVoiceCallAgentDetails.email : "-"}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <></>

                    }
                </div>

            </div>
            <div className="pb-4 audio-room-submit-button col-12">
                {
                    (inCallNotificationIdRef) ?
                        <>
                            <Button size="lg" className="ml-1" onClick={() => { terminateCall() }} variant="danger" title="End call"><i className="bi bi-telephone-fill"></i></Button>
                            {(addThirdUserButton) ?
                                <div className="btn-tooltip-container">
                                    <Button size="lg" className="ml-1" onClick={() => { setAddThirdUserFlag(true); }} variant="secondary" title="Add agent"><i className="bi bi-person-plus-fill"></i></Button>
                                    <AgentStatusInfoTooltip tooltipClass="audioTooltip" />
                                </div>
                                : <></>}
                            <Button size="lg" className="ml-1 mr-1" onClick={() => handleAudioMute()} variant={(voiceAudioMute) ? "warning" : "secondary"} title="Mic mute / unmute"><i className={(voiceAudioMute) ? "bi bi-mic-mute-fill" : "bi bi-mic-fill"}></i></Button>
                            {((!holdCallDetails || (holdCallDetails && holdCallDetails.inCallRefId && inCallNotificationIdRef && inCallNotificationIdRef === holdCallDetails.inCallRefId)) && !(agentToAgentOutBoundVoiceCallAgentDetails && !outBoundCallLocationDetails && !inBoundCallConnection && !TenantNotificationDetails) && !(outBoundCallLocationDetails && !inBoundCallConnection && !TenantNotificationDetails && !agentToAgentOutBoundVoiceCallAgentDetails)) ? <Button size="lg" className="ml-1 mr-1" onClick={() => putCallOnHold('voice')} variant="secondary" title="Hold"> <i className="bi bi-pause-circle-fill"></i></Button> : <></>}
                            <Button size="lg" className="ml-1 mr-1" variant="success" onClick={(e) => { setShowKeypadInboundCall(true) }} title="Keypad"><i className="bi bi-keyboard"></i></Button>
                            <Button size="lg" className="mr-1" variant="secondary" disabled > {("0" + Math.floor((audioCallTimer / 60000) % 60)).slice(-2)}:{("0" + Math.floor((audioCallTimer / 1000) % 60)).slice(-2)}</Button>
                        </>
                        :
                        <></>
                }
            </div>

            {
                showKeypadInboundCall ?
                    <AppModal
                        title={"Select Your Number"}
                        bodyText={""}
                        showCloseButton={true}
                        closeButtonEventEmitter={() => { setShowKeypadInboundCall(false); setIncomingCallVerifiedPhNumber("") }}
                    >
                        <>
                            <div className="out-bound-dialer">
                                <div className="audio-details-card">
                                    <div key={1}>

                                        <div className="row d-flex align-items-center m-2">
                                            <div className="col-6">
                                                <label>
                                                    Selected Digits
                                                </label>
                                            </div>
                                            <div className="col-6">
                                                <div className="">
                                                    <input type="text" name="incomingCallVerifiedPhNumber" onKeyDown={disableBackSpace} value={incomingCallVerifiedPhNumber} className="form-control" onChange={(event: any) => { sendDigit(event?.target.value.slice(-1), "incoming") }} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="keys">
                                            <div className="key-row">
                                                <button className="btn btn-circle btn-default" onClick={() => { sendDigit('1', "incoming") }}>1</button>
                                                <button className="btn btn-circle btn-default" onClick={() => { sendDigit('2', "incoming") }}>2</button>
                                                <button className="btn btn-circle btn-default" onClick={() => { sendDigit('3', "incoming") }}>3</button>
                                            </div>
                                            <div className="key-row">
                                                <button className="btn btn-circle btn-default" onClick={() => { sendDigit('4', "incoming") }}>4</button>
                                                <button className="btn btn-circle btn-default" onClick={() => { sendDigit('5', "incoming") }}>5</button>
                                                <button className="btn btn-circle btn-default" onClick={() => { sendDigit('6', "incoming") }}>6</button>
                                            </div>
                                            <div className="key-row">
                                                <button className="btn btn-circle btn-default" onClick={() => { sendDigit('7', "incoming") }}>7</button>
                                                <button className="btn btn-circle btn-default" onClick={() => { sendDigit('8', "incoming") }}>8</button>
                                                <button className="btn btn-circle btn-default" onClick={() => { sendDigit('9', "incoming") }}>9</button>
                                            </div>
                                            <div className="key-row">
                                                <button className="btn btn-circle btn-default" style={{ fontSize: '26px' }} onClick={() => { sendDigit('*', "incoming") }}>*</button>
                                                <button className="btn btn-circle btn-default" onClick={() => { sendDigit('0', "incoming") }}>0</button>
                                                <button className="btn btn-circle btn-default" onClick={() => { sendDigit('#', "incoming") }}>#</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>

                    </AppModal>
                    :
                    <></>
            }


            {(addThirdUserFlag) ?
                <AppModal
                    title={""}
                    bodyText={""}
                    showCloseButton={true}
                    closeButtonEventEmitter={() => { setAddThirdUserFlag(false); }}
                >
                    <Teams addAgentModel={true} addAgentModelCallBackFunction={(agentDetails: any) => { addThirdUsers(agentDetails); }} />
                </AppModal>
                :
                <></>
            }
        </div >
    );
};

export default AudioRooms;
